export const GET_UPDATES_DETAILS = "GET_UPDATES_DETAILS";
export const SUCCESS_GET_UPDATES_DETAILS = "SUCCESS_GET_UPDATES_DETAILS";
export const ERROR_GET_UPDATES_DETAILS = "ERROR_GET_UPDATES_DETAILS";
